import React from 'react';
import { FieldErrors, UseFormRegister } from 'react-hook-form';
import TextArea from 'v2/form/TextArea/TextArea';
import { SearchQuestionEntity } from 'v2/models';
import { ProviderProposalTokenResponseFields } from './ProposalResponse';

interface StepQuestionProps {
  register: UseFormRegister<ProviderProposalTokenResponseFields>;
  errors: FieldErrors<ProviderProposalTokenResponseFields>;
  question: SearchQuestionEntity;
}

interface FieldError {
  response: {
    message: string;
  };
}

const StepQuestion = ({ errors, register, question }: StepQuestionProps) => {
  const key = `answers_${question.id}`;
  const fieldError = errors[key] as FieldError | undefined;
  const errMsg = fieldError?.response.message;

  const registerObj = register(`${key}.response`);

  return (
    <div className="p-5 border-bottom">
      <label className="text-primary-dark">{question.name}</label>
      <TextArea
        className={errMsg ? 'field-error-box' : ''}
        register={{ ...registerObj }}
        rows={5}
        autoComplete="off"
        required={true}
        placeholder="Type your answer here..."
      />
      {errMsg ? <p className="text-danger">{errMsg}</p> : null}
    </div>
  );
};

export default StepQuestion;
